import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { MOCK_STATUS, MOCK_URL_SEATMAP, SEATMAP_PACK_SELECTED_URL_EXTENSION, SEATMAP_SEGMENT_URL_EXTENSION, URL_BFM_PNRS_LIST } from '@ibe.config';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
import * as i2 from "@angular/common/http";
var INDRASeatmapService = /** @class */ (function () {
    function INDRASeatmapService(api, http) {
        this.api = api;
        this.http = http;
    }
    INDRASeatmapService.prototype.INDRA_getSeatmap = function (pnr, segment, packCode) {
        if (MOCK_STATUS.SEAT_MAP) {
            return this.http.get(MOCK_URL_SEATMAP);
        }
        else {
            if (packCode) {
                return this.api.INDRA_get(URL_BFM_PNRS_LIST + '/' + pnr + SEATMAP_SEGMENT_URL_EXTENSION + segment + SEATMAP_PACK_SELECTED_URL_EXTENSION + packCode);
            }
            else {
                return this.api.INDRA_get(URL_BFM_PNRS_LIST + '/' + pnr + SEATMAP_SEGMENT_URL_EXTENSION + segment);
            }
        }
    };
    INDRASeatmapService.prototype.INDRA_getCabinTemplateURL = function (aircraftFile) {
        var url = "./assets/data/" + aircraftFile;
        if (aircraftFile) {
            return this.http.get(url).pipe(map(function (response) { return response; }));
        }
        // return empty cabins if no mock for plane
        return of({ cabins: [], currency: '' });
    };
    INDRASeatmapService.ngInjectableDef = i0.defineInjectable({ factory: function INDRASeatmapService_Factory() { return new INDRASeatmapService(i0.inject(i1.INDRAApiService), i0.inject(i2.HttpClient)); }, token: INDRASeatmapService, providedIn: "root" });
    return INDRASeatmapService;
}());
export { INDRASeatmapService };
